import { render } from "./AuthReader.vue?vue&type=template&id=687137f2&scoped=true"
import script from "./AuthReader.vue?vue&type=script&lang=ts"
export * from "./AuthReader.vue?vue&type=script&lang=ts"

import "./AuthReader.vue?vue&type=style&index=0&id=687137f2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-687137f2"

export default script